/**
 * localStorage keys and helpers for whitelabel-related guided tours
 * (create flow, payment help, add funds help).
 */

/** Create whitelabel tour — completed / dismissed */
export const WL_CREATE_TOUR_STORAGE_KEY = "pg_wl_create_tour_v1_completed";

export function isWlCreateTourCompleted(): boolean {
  try {
    return window.localStorage.getItem(WL_CREATE_TOUR_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function setWlCreateTourCompleted(): void {
  try {
    window.localStorage.setItem(WL_CREATE_TOUR_STORAGE_KEY, "1");
  } catch {
    /* ignore */
  }
}

/** Payment help tour */
export const WL_PAYMENT_HELP_TOUR_STORAGE_KEY = "pg_wl_payment_help_tour_v1_completed";

export function isWlPaymentHelpTourCompleted(): boolean {
  try {
    return window.localStorage.getItem(WL_PAYMENT_HELP_TOUR_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

/** Add funds help tour */
export const WL_ADD_FUNDS_HELP_TOUR_STORAGE_KEY = "pg_wl_add_funds_help_tour_v1_completed";

export function isWlAddFundsHelpTourCompleted(): boolean {
  try {
    return window.localStorage.getItem(WL_ADD_FUNDS_HELP_TOUR_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}
